// Libraries
import Cookies from 'js-cookie'

// Inirialization
document.addEventListener("DOMContentLoaded", function(event) { 
    new modalCookiesController(document.getElementById('cookies-banner'));
});

// Clasees
class modalController {

    constructor(modal) {
        this.modal = modal
        this.init()
    }
    init() {
        this.modal.addEventListener('click', (e) => {
            if (!e.target.closest('.popup__window')) {
                this.close()
            }
        });
    }
    open() {
        this.modal.classList.add('active')
        document.body.classList.add('overflow-hidden')
    }
    close() {
        this.modal.classList.remove('active')
        document.body.classList.remove('overflow-hidden')
    }
}

class modalCookiesController extends modalController {
    constructor(modal = null) {
        super(modal)
        this.load();
        
    }
    load() {
        if (!this.existCookies()) {
            this.open()
        }

        this.buttons()
    }
    buttons() {
        this.acceptAllCookiesButton = document.getElementById('cookies-banner-button-all')
        this.declineUnnecessaryCookiesButton = document.getElementById('cookies-banner-button-decline-unnecessary')

        if (this.acceptAllCookiesButton) {
            this.acceptAllCookiesButton.addEventListener('click', () => {
                super.close()
                this.reload()
                this.allowAllCookies()
            });
        }
        
        if (this.declineUnnecessaryCookiesButton) {
            this.declineUnnecessaryCookiesButton.addEventListener('click', () => {
                super.close()
                this.reload()
                this.allowNecessaryCookies()
            });
        }
    }
    allowAllCookies() {
        Cookies.set('cookies', 'all', { expires: 365 })
    }
    allowNecessaryCookies() {
        Cookies.set('cookies', 'necessary', { expires: 365 })
    }
    reload() {
        window.location.reload();
    }
    existCookies() {
        return Cookies.get('cookies');
    }
}